import React from 'react';
import {observer} from "mobx-react-lite"
import {ValidationRuleBytesProps} from "common/validation/rules/ValidationRuleBytes";
import {ValidationRuleNames} from "common/validation/rules/ValidationRule";
import useUIValidator from "common/validation/component/UseUIValidator";

export interface UIInputProps {
    type?: string;
    value?: any;
    valueChanged?: (value: any) => void;
    autoFocus?: boolean;
    setFocus?: boolean;
    full?: boolean;
    readOnly?: boolean;
    disabled?: boolean;
    className?: string;
    placeholder?: string;
    attrs?: React.InputHTMLAttributes<HTMLInputElement>;
    onKeyEnter?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
    rules?: Array<ValidationRuleNames | ((value: any) => string | undefined)>;
    bytes?: ValidationRuleBytesProps;
}

function UIInput({
                     type = "text",
                     value,
                     valueChanged,
                     autoFocus,
                     setFocus,
                     full,
                     readOnly,
                     disabled,
                     className,
                     placeholder,
                     attrs = {},
                     onKeyEnter,
                     rules = [],
                     bytes
                 }: UIInputProps) {
    const {required, valueChecker, errorClassName, setElement} = useUIValidator({rules: rules, bytes: bytes})
    // let inputElement;

    React.useEffect(() => {
        // setElement(inputElement)
        valueChecker.setValue(value || "");
    }, [value]);

    return (
        <input
            ref={(element) => {
                setElement(element);
                setFocus === true && element?.focus()
            }}
            type={type}
            value={value || ''}
            className={className}
            placeholder={placeholder}
            readOnly={readOnly}
            disabled={disabled}
            autoFocus={autoFocus}
            {...attrs}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                attrs.onChange && attrs.onChange(event);
                valueChanged && valueChanged(event.target.value)
            }}
            onKeyUp={(event: React.KeyboardEvent<HTMLInputElement>): void => {
                attrs.onKeyUp && attrs.onKeyUp(event);
                if (onKeyEnter != null && event.key === "Enter") {
                    onKeyEnter(event);
                }
            }}
            required={required}
            data-security={"off"}
            data-value-rule={rules}
            data-value-bytes={JSON.stringify(bytes || {})}
            data-validation-message={valueChecker.message}
        />
    );
}

export default observer(UIInput);
